<template lang="pug">
  .b2b-login-form-lyntia
    b2b-login-form-generic(
      :css='css',
      :logo='logo'
      :next='next'
      :localproject='localproject',
      :logomenu='logomenu' )
</template>
<script>
import B2bLoginFormGeneric from '@/components/logingeneric/B2bLoginFormGeneric'

export default {
  name: 'login-form-lyntia',
  data () {
    return {
      css: 'lyntia.css',
      logo: 'lyntia.jpg',
      next: '/lyntia/new-password-form',
      localproject: 'lyntia',
      logomenu: 'lyntia.png'
    }
  },
  components: {
    B2bLoginFormGeneric
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .ods-input, .ods-input__inner {
    background-color: #f3ecfa!important;
    color: #f3ecfa!important;
    border: 1px solid #351b51;
  }
  ::v-deep .ods-button__custom {
    background-color: #351b51!important;
  }
    ::v-deep .ods-p-0 {
    color: #351b51!important;
  }

  ::v-deep .ods-button__custom:active,
  ::v-deep .ods-button__custom:hover,
  ::v-deep .ods-button__custom:focus{
    background-color: #f38f25!important;
  }
  ::v-deep .ods-p-0:active,
  ::v-deep .ods-p-0:hover,
  ::v-deep .ods-p-0:focus{

    color: #f38f25!important;
  }
  .login-form__title {
    color: #351b51!important;
  }
  .login-form {
    padding-top: 1rem;
  }
  ::v-deep .ods-button.ods-p-32 {
    color: #351b51!important;
  }
</style>
